export const SOIL_SOURCES = [
  {
    id: 'soilscapes-england',
    region: 'england',
    kind: 'wms',
    wmsBase:
      'https://www.landis.org.uk/arcgis/services/UKSoilObservatory/Soilscapes_Cranfield/MapServer/WmsServer',
    layerName: '0',
    scaleNote: '1:250k',
    minZoom: 8,
    licenceStatus: 'verified',
    precedence: 100,
  },
  {
    id: 'soilscapes-wales',
    region: 'wales',
    kind: 'wms',
    wmsBase:
      'https://www.landis.org.uk/arcgis/services/UKSoilObservatory/Soilscapes_Cranfield/MapServer/WmsServer',
    layerName: '0',
    scaleNote: '1:250k',
    minZoom: 8,
    licenceStatus: 'verified',
    unverified: false,
    precedence: 100,
  },
  {
    // MOVED OFF druid.hutton.ac.uk 18/08/2026. Hutton's own ArcGIS Server has
    // been unreachable host-wide since at least 14/08 (the web adaptor answers,
    // but `/arcgis/rest/info` — which describes the server and needs no
    // published service — returns "Could not access any server machines").
    // Scotland's national soil map viewer at map.environment.gov.scot/Soil_maps
    // reads the same endpoints and is down with it, so the outage is Hutton's.
    //
    // Hutton publish the same dataset on their own ArcGIS Online account, which
    // is Esri-hosted and independent of that server. Same publisher, same data,
    // so this is a hosting change and not a data-source change: it does not
    // reopen the Hutton licence question. `TilesOnly`, hence `arcgis-tiles`.
    id: 'hutton-soil-250k-scotland',
    region: 'scotland',
    kind: 'arcgis-tiles',
    serviceUrl:
      'https://services8.arcgis.com/GUWZHTCSOJuIKNzF/arcgis/rest/services/Hutton_Soils_250K_SSKIB_OSGB_AGOL_FL/MapServer',
    scaleNote: '1:250k',
    minZoom: 8,
    // The cache advertises LODs to 22 and is actually built to 14, measured with
    // real requests on 18/08/2026. Past that the adapter draws the z14 tile
    // scaled up rather than letting the layer disappear at field zoom.
    maxCachedZoom: 14,
    licenceStatus: 'verified',
    precedence: 100,
  },
  {
    // STILL ON druid, and therefore still down. Checked 18/08/2026 across both
    // Hutton ArcGIS Online orgs, their tile org, the UK Soil Observatory and
    // Cranfield: the 1:25k soil map is published nowhere else. It is left
    // pointing here deliberately, so it reports the provider as unavailable and
    // returns on its own when Hutton restore the server. Davin's call: leave
    // the Scottish layers that need heavier work until they can be reapproached.
    id: 'hutton-soil-25k-scotland',
    region: 'scotland',
    kind: 'arcgis-rest',
    serviceUrl:
      'https://druid.hutton.ac.uk/arcgis/rest/services/Hutton_Soils_25K_Apps/MapServer',
    layerId: 0,
    scaleNote: '1:25k partial',
    minZoom: 10,
    licenceStatus: 'verified',
    precedence: 200,
  },
];
